/*
 * SecondFirst add-to-cart toast.
 *
 * Keeps the <cart-notification> element API (getSectionsToRender / setActiveElement /
 * renderContents / open / close) so the product form, quick-add and the custom
 * product page keep working — but instead of Dawn's dropdown it shows the site's
 * existing .sf-cart-toast pill (centered, drops in from the top, auto-dismisses).
 *
 * The same .sf-cart-toast is also created by sf-animations.js for the quick-add
 * modal; both dedupe on the live .sf-cart-toast in the DOM so only one shows.
 *
 * renderContents() just opens the toast (no section injection), which also fixes
 * Dawn's crash on the missing #cart-icon-bubble section in this custom header.
 * The cart badge updates independently via the published cartUpdate event.
 */
class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.toastVisibleMs = 2200;
  }

  // Callers do `cart.getSectionsToRender().map(...)`; the toast needs no sections.
  getSectionsToRender() {
    return [];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  // Add-to-cart calls renderContents(response); the toast only needs to show itself.
  renderContents() {
    this.open();
  }

  open() {
    // Dedupe: if a toast is already on screen (e.g. shown by sf-animations.js for
    // the quick-add modal), don't stack a second one.
    if (document.querySelector('.sf-cart-toast:not(.sf-toast-exit)')) return;

    const toast = document.createElement('div');
    toast.className = 'sf-cart-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML =
      '<span class="sf-cart-toast__icon">' +
        '<svg viewBox="0 0 24 24"><polyline points="4 12 9 17 20 6"></polyline></svg>' +
      '</span>Added to cart';
    document.body.appendChild(toast);

    const remove = () => {
      if (toast.parentNode) toast.parentNode.removeChild(toast);
    };

    setTimeout(() => {
      toast.classList.add('sf-toast-exit');
      toast.addEventListener('animationend', remove, { once: true });
      setTimeout(remove, 600); // fallback if animationend never fires
    }, this.toastVisibleMs);
  }

  close() {
    const toast = document.querySelector('.sf-cart-toast');
    if (toast && toast.parentNode) toast.parentNode.removeChild(toast);
  }
}

customElements.define('cart-notification', CartNotification);
